module.exports = __webpack_public_path__ + "static/P5-68ccd364362e7478817e9f2c96da043b.jpeg";